export function range(start: number, end: number, step: number = 1): number[] {
  if (end < start) {
    return [];
  }
  const length = Math.floor((end - start) / step);
  const array = new Array(length);
  for (let i = 0; i <= length; i++) array[i] = start + i * step;
  return array;
}
